import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { onUserLogout } from './app/core/monitoring/datadog-session';

window.onbeforeunload = () => {
  onUserLogout();
};

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
